import React from "react";
import { UseFormRegister } from "react-hook-form";
import { cn } from "@/utils";

interface TextAreaProps {
  label?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register: UseFormRegister<any>;
  name: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  errors?: any;
  labelClass?: string;
  id?: string;
  className?: string;
}

const TextArea: React.FC<TextAreaProps> = ({
  label,
  register,
  name,
  className,
  required = false,
  placeholder,
  errors
}) => {
  return (
    <div className="relative">
      <label htmlFor={name}>{label}</label>
      <textarea
        {...register(name, { required })}
        id={name}
        placeholder={placeholder}
        className={cn(
          "block border  p-4 w-full bg-transparent focus:outline-none",
          errors ? "error-text" : "text-dark border-dark placeholder:text-dark",
          className
        )}
        rows={4}
      ></textarea>
      {errors && <span className="error-text">{errors.message}</span>}
      {errors && errors.type === "required" && (
        <span className="error-text">This field is required</span>
      )}
    </div>
  );
};

export default TextArea;
